import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SdkIndexComponent } from './sdk-index.component';

const appRoutes: Routes = [
  {
    path: '',
    component: SdkIndexComponent,
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: ''
  }
];

export const SdkRoutingProviders: any[] = [];

export const SdkRouting: ModuleWithProviders<any> =
  RouterModule.forChild(appRoutes);
